import { ref } from 'vue'

export const deliveryTimeOrder = ref('')
